import { DEFAULT_CONFIGS } from "./defaults";
import { VIDEO_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers";
const pluginVideo = (config) => {
  return {
    config: { ...DEFAULT_CONFIGS.viewer, ...config },
    type: VIDEO_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginVideo
};
//# sourceMappingURL=viewer.js.map
